import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getNotificationsOptions,
  getUnreadNotificationsOptions,
  markAsReadMutation,
  markMultipleAsReadMutation,
  markAllAsReadMutation,
} from '@/shared/api/generated/@tanstack/react-query.gen';
import type {
  NotificationFilters,
} from '../model/types';

// Query factory
export const notificationQueries = {
  all: () => ['notifications'] as const,
  lists: () => [...notificationQueries.all(), 'list'] as const,
  list: (params?: NotificationFilters) => [...notificationQueries.lists(), params] as const,
  unread: () => [...notificationQueries.all(), 'unread'] as const,
  unreadList: (params?: NotificationFilters) => [...notificationQueries.unread(), params] as const,
};

// Custom hooks for queries
export const useNotifications = (params?: NotificationFilters) => {
  return useQuery({
    ...getNotificationsOptions({
      query: params,
    }),
  });
};

export const useUnreadNotifications = (params?: NotificationFilters) => {
  return useQuery({
    ...getUnreadNotificationsOptions({
      query: params,
    }),
    // 읽지 않은 알림은 30초마다 자동 갱신
    refetchInterval: 30000,
  });
};

// Mutations
export const useMarkAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    ...markAsReadMutation(),
    onSuccess: () => {
      // Generated query key를 올바르게 매칭하여 무효화
      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey[0] as { _id?: string } | undefined;
          return key?._id === 'getNotifications' ||
                 key?._id === 'getUnreadNotifications';
        }
      });
    },
  });
};

export const useMarkMultipleAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    ...markMultipleAsReadMutation(),
    onSuccess: () => {
      // Generated query key를 올바르게 매칭하여 무효화
      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey[0] as { _id?: string } | undefined;
          return key?._id === 'getNotifications' ||
                 key?._id === 'getUnreadNotifications';
        }
      });
    },
  });
};

export const useMarkAllAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    ...markAllAsReadMutation(),
    onSuccess: () => {
      // Generated query key를 올바르게 매칭하여 무효화
      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey[0] as { _id?: string } | undefined;
          return key?._id === 'getNotifications' ||
                 key?._id === 'getUnreadNotifications';
        }
      });
    },
  });
};
